module.exports = __webpack_public_path__ + "static/img/22222.3f0965d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pro/park/22222.png
// module id = Lg92
// module chunks = 0